<div class="row">  
  <span class="col-md-12 text-right boldlbl">Page 10 of 10</span>  
</div>
<div *ngIf=" trcAppForm.registration_Number !== null && sessionStorage.getItem('urlNbr') !== '0' ; else setElse">
    <div class="row p-4">
        <div class="col-md-12 text-center">
            <h3>{{eAppRegConstant.PageHeader}}</h3>
            <h4>Application Confirmation</h4>
        </div>
    </div>

    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <p>This is a confirmation receipt for your submitted {{sessionStorage.TRCReceiptType}}.  <b>Please do not register your business more than once, for any reason.</b></p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <jhi-eappreg-confirm-letter></jhi-eappreg-confirm-letter>
                </div>
            </div>
        </div>
    </div>
    <div class="row d-print-none">
        <div class="col-md-12 text-center">
            <button class="btn btn-primary my-2" (click)="print_page()">Print</button>&nbsp;
            <button class="btn btn-primary my-2" routerLink="/eappreg_criteria">Exit</button>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-md-12 justify-content-center">
            <lib-survey-eos-link [WEB_EOS_URL]="WEB_EOS_URL"></lib-survey-eos-link>
        </div>
    </div>
</div>
 <ng-template #setElse>
<div *ngIf=" sessionStorage.getItem('urlNbr') === '0' ; else noData">
<lib-common-rejected [headerstmt]="headerstmt" [urlWebFilingId]="sessionStorage.getItem('urlWebFilingId')" ></lib-common-rejected>
</div>
</ng-template>
<ng-template #noData>
    <lib-pmt-receipt-basic [web_filing_id]="urlWebFilingId" [nbr]="urlNbr"></lib-pmt-receipt-basic>
</ng-template>
